import React from 'react';
export const Input = ({
  placeholder,
  value,
  onChange,
  className,
  ...props
}) => {
  return <input type="text" placeholder={placeholder} value={value} onChange={onChange} className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 ${className}`} {...props} data-id="element-3806" data-mp="1jct6p6ocb7dh" />;
};